import { render, staticRenderFns } from "./MiniGameTemplateLookup.vue?vue&type=template&id=99108350&lang=pug"
import script from "./MiniGameTemplateLookup.vue?vue&type=script&lang=js"
export * from "./MiniGameTemplateLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports